/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Logs} from "../../APIClient.jsx";
import Console from "../Console.jsx";

class ContainerLogs extends Component {
    constructor() {
        super();

        this.state = {
            logs: [],
            error: null
        }
    }

    async fetchData() {
        let {nodeId, containerId} = this.props

        let logs = await Logs.getContainerLogs(containerId, `containerLog`)
        if (logs.error) {
            this.setState({error: "Failed to fetch logs. Displaying cached logs."})
            return
        }
        let messages = (logs?.logs ?? [])


        this.setState({logs: messages})
    }

    componentDidMount() {
        this.fetchData()

        this.interavl = setInterval(() => {
            this.fetchData()

        }, 10000)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId || prevProps.containerId !== this.props.containerId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        clearInterval(this.interavl)
    }


    render() {
        let {logs, error} = this.state
        return (
            <div>

                <Console logs={logs} titel={"Container logs"} error={error}/>

            </div>
        );
    }
}

ContainerLogs.propTypes = {};

ContainerLogs.defaultProps = {};


export default ContainerLogs;